import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface MemoryListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class MemoryListPage extends Component<MemoryListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.memory.list }}
                pages={{
                    entity: InferenceEntities.memory(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}